import { Box, Flex } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { useTranslation } from "react-i18next"
import { Icon } from "../../../common/icons"
import { IoClose } from "react-icons/io5"
import { MODAL_Z_INDEX } from "../../../../constants"
import { blendWithWhiteBackground } from "../../../../util"

const BadgeOverlayModal = ({ isMobile, isLandscape, onCancel }) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { t } = useTranslation()
  return (
    <Box
      width="100vw"
      height="100vh"
      position="fixed"
      background="white"
      zIndex={MODAL_Z_INDEX}
      top="0"
      left="0"
      backgroundColor="rgba(255, 255, 255, 0.5)"
    >
      <Flex
        minW={isMobile && !isLandscape ? "300px" : "400px"}
        width={isMobile ? "50vw" : "500px"}
        position="absolute"
        top="50%"
        left="50%"
        padding="1rem"
        marginRight="-50%"
        transform="translate(-50%, -50%)"
        flexDirection="column"
        backgroundColor="rgba(255, 255, 255)"
        borderRadius="0.375rem"
        borderWidth="1px"
        borderStyle="solid"
        borderColor={roomStyles.servicePanelElementBorder ?? "gray.300"}
        bg={
          blendWithWhiteBackground(
            roomStyles.servicePanelElementModalBackground
          ) ?? "white"
        }
        color={roomStyles?.servicePanelElementPrimaryText ?? "black"}
      >
        <Flex
          background={
            blendWithWhiteBackground(
              roomStyles.servicePanelElementModalBackground
            ) ?? "white"
          }
          pos="absolute"
          width="19px"
          height="19px"
          borderRadius="50%"
          right="-9px"
          top="-9px"
          alignItems="center"
          justifyContent="center"
          border="1px solid"
          borderColor={roomStyles.servicePanelElementBorder ?? "#CBD5E0"}
          cursor={"pointer"}
          zIndex={1}
          onClick={onCancel}
        >
          <Icon
            src={IoClose}
            fontSize="0.8rem"
            marginLeft="1px"
            color={roomStyles?.servicePanelElementPrimaryText ?? "#000"}
          />
        </Flex>

        <Box
          fontSize="1.5rem"
          lineHeight="1.5"
          fontWeight="700"
          justifyContent="center"
          zIndex="10000001"
          textAlign="center"
          marginBottom="0.5rem"
        >
          {t("Item removed")}
        </Box>
        <Flex
          alignItems="center"
          justifyContent="center"
          marginTop="0.4rem"
          textAlign="center"
          flexDirection="column"
        >
          <Box>
            {t("This product has been removed since you clicked to buy")}
          </Box>
        </Flex>
      </Flex>
    </Box>
  )
}

export default BadgeOverlayModal
